import React, { useCallback, useRef } from "react";
import wizard_css from "../../inspection.module.css";

export default function GpmInput({ check, topLevel, setCheckValue }) {
  const input = useRef();
  const setValue = useCallback(
    (value) => {
      if (input.current && window.$(input.current).get(0).validity.valid) {
        setCheckValue(value, check.id, topLevel);
      } else {
        window.$(input.current).val(check.value);
      }
    },
    [check.id, check.value, setCheckValue, topLevel]
  );

  return (
    <label className={wizard_css["text"]}>
      <span>{check.title}</span>
      <input
        ref={(ref) => (input.current = ref)}
        autoFocus
        type="number"
        min="0"
        max="10000"
        readOnly={check.locked}
        onInput={(event) => setValue(event.target.value)}
        value={check.value || ""}
      />
    </label>
  );
}
